// extracted by mini-css-extract-plugin
export default {"highlightOverlay":"styles-module__highlightOverlay___gU4PU","ai-draft-highlight":"styles-module__ai-draft-highlight___wW8lQ","anchor":"styles-module__anchor___TnMFF"};